module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_5_10.c067d4db.png";